/**
 * 密码视口
 */
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'layout-passport',
  templateUrl: './passport.component.html',
  styleUrls: ['./passport.component.scss']
})
export class PassportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
